import script from "./IdCardList.vue?vue&type=script&setup=true&lang=js"
export * from "./IdCardList.vue?vue&type=script&setup=true&lang=js"

import "./IdCardList.vue?vue&type=style&index=0&id=dac57196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac57196"]])

export default __exports__